import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Card, Dropdown, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../common/actions';
import {pageSizes} from '../../../common/constants/lists';
import {fullDate} from '../../../common/constants/datesFormat';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import TablePaginator from '../../../common/components/tablePaginator';
import './amountReport.scss';

class TableAmountReport extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }
  componentDidMount() {
    this.props.changeAmountReportDetailListPageSize(pageSizes[1].value);
  }

  onPageClick(value) {
    this.props.changeAmountReportDetailListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeAmountReportDetailListPageSize(data.value);
  }

  handleViewDetailClick(order) {
    this.props.viewAmountReportDetail(order);
  }

  renderLoaderAmountReport() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderAmountReportDetail();
  }

  renderAmountReportDetail() {
    const {amountDetail} = this.props;

    if (!amountDetail.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='100%'>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return amountDetail.map((element, index) => {
      const dateFormatted = element.authorizationDate ? moment(element.authorizationDate).format(fullDate) : '';
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{dateFormatted.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{element.providerName}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.userAuthorizationRequest ? element.userAuthorizationRequest.toUpperCase() : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {element.userAuthorization ? element.userAuthorization.toUpperCase() : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.orderCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='right'>{element.partQuantity || 0}</Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{getNumericValue(element.unitFob, 2)}</Table.Cell>
          <Table.Cell textAlign='right'>{'$'}{getNumericValue(element.totalFob, 2)}</Table.Cell>
          <Table.Cell textAlign='center'>{element.salesIcc}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems, loading} = this.props;

    if (totalItems <= pageSize || loading) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card fluid raised>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Fecha Autorización</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Proveedor</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Usuario Solicitud</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Usuario Autorización</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>No. Pedido</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Part number</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>FOB unitario</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>FOB total</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>ICC</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderLoaderAmountReport()}</Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.amountReportDetail.loading,
    'amountDetail': state.amountReportDetail.listByPage,
    'pageNumber': state.amountReportDetail.pageNumber,
    'pageSize': state.amountReportDetail.pageSize,
    'totalItems': state.amountReportDetail.list.length,
  };
};

const {viewAmountReportDetail, changeAmountReportDetailListPage, changeAmountReportDetailListPageSize} = Actions;

export default connect(mapStateToProps, {
  viewAmountReportDetail,
  changeAmountReportDetailListPage,
  changeAmountReportDetailListPageSize,
})(TableAmountReport);
